import { api } from "..";

// Flips the dealer's real-money casino enablement in sinek (the source of
// truth). The endpoint is Admin-only and step-up protected; step-up is
// handled globally by the axios interceptor. `mirrorSynced: false` means the
// flip is saved but the game-server mirror push failed — the reconciler
// catches it up automatically.

export interface UpdateMainDealerCasinoRealModeParams {
  dealerId: number;
  enabled: boolean;
}

export interface MainDealerCasinoRealModeResult {
  id: number;
  username: string;
  casinoRealEnabled: boolean;
  mirrorSynced: boolean;
}

export const updateMainDealerCasinoRealMode = async (
  params: UpdateMainDealerCasinoRealModeParams
): Promise<MainDealerCasinoRealModeResult> => {
  const res = await api.client.put(
    `/dealers-new/${params.dealerId}/casino-real-enabled`,
    { enabled: params.enabled }
  );
  return res.data;
};
